import QuoteReviewErrorsForItems from "./quoteReviewErrorsForItems";

const QuoteReviewErrors = ({
    quoteItems
}) => {

    return (
        <div className="mb-5">
            <h4>Errors</h4>
            <div className="mb-4">
                <i className="bi bi-info-circle m-2 text-danger"></i>Errors must be resolved before the quote can be finalised.
            </div>
            <QuoteReviewErrorsForItems
                quoteItems={quoteItems}
            /> 
        </div>
    );
}
export default QuoteReviewErrors;